import { NewsWrapper } from "styles/jss/Home.styles";
import { Container, Grid, useTheme } from "@mui/material";
import NewsItemBox from "./NewsItemBox";
import NewsListItem from "./NewsListItem";
import { MainTitle } from "../../Title";
import { useTranslation } from "next-i18next";
import Loader from "../../Loader";
import { isEmpty } from "../../../utils/helperFunction";

export default function NewsSection({ news, isLoading, isErrorNews }) {
  const { t } = useTranslation(["homePage"]);
  const theme = useTheme();
  return (
    <NewsWrapper>
      <Container
        sx={{
          [theme.breakpoints.down("sm")]: {
            p: 0,
          },
        }}
      >
        <MainTitle textAlign={"center"}>{t("news-title")}</MainTitle>
        {isLoading ? (
          <Loader />
        ) : !isErrorNews && !isEmpty(news.data) ? (
          <Grid
            container
            rowSpacing={{ xs: 4, lg: 0 }}
            columnSpacing={{ sm: 0, md: 2, lg: 5 }}
          >
            <Grid item xs={12} lg={8}>
              <Grid
                container
                rowSpacing={{ xs: 0, sm: 1.5 }}
                columnSpacing={{ xs: 1.5 }}
              >
                {!!news?.data[0]?.attributes && (
                  <Grid item xs={12} sm={12}>
                    <NewsItemBox
                      typeSize={"lg"}
                      width={747}
                      height={520}
                      {...news?.data[0]}
                    />
                  </Grid>
                )}
                {!!news?.data[1]?.attributes && (
                  <Grid item xs={12} sm={6}>
                    <NewsItemBox
                      typeSize={"sm"}
                      width={369}
                      height={296}
                      {...news?.data[1]}
                    />
                  </Grid>
                )}
                {!!news?.data[2]?.attributes && (
                  <Grid item xs={12} sm={6}>
                    <NewsItemBox
                      typeSize={"sm"}
                      width={369}
                      height={296}
                      {...news?.data[2]}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} lg={4}>
              <NewsListItem news={news?.data} />
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Container>
    </NewsWrapper>
  );
}
